export const EMAIL_OTP_VALIDATION_RESPONSE_STATUS = {
    OK: 'OK',
    BLOCKED: 'BLOCKED',
    INCORRECT: 'INCORRECT',
    INCORRECT_RETRY: 'INCORRECT_RETRY',
    INCORRECT_NO_RETRY: 'INCORRECT_NO_RETRY',
    EXPIRED_RETRY: 'EXPIRED_RETRY',
    EXPIRED_NO_RETRY: 'EXPIRED_NO_RETRY',
};
